import React, { useEffect, useState } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { Fade, Paper } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { FormattedMessage } from 'react-intl';
import { SALES_VAT } from '../../../common/charts/chartDataConfig';
import DashboardChartWrapper from '../DashboardChartWrapper';
import { DASHBOARD_MACHINE_ID } from '../../../../actions/utils';
import { formatTimestampAsDate, getDateAfterDeductFromToday } from '../../../../utils/dates-utils';
import { TranslationsContext } from '../../../../config/translations';
import { localeMap } from '../../../../utils/datefns-locale';
import { clearTopCategories, fetchDashboardTopCategories } from '../../../../actions/dashboard-actions';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import NoDataAvailable from '../../../common/charts/NoDataAvailable';

const styles = (() => ({}));

const TopSalesCategory = ({
                            dashboardReports,
                            machines,
                            allMachineIDs,
                            selectedMachineIds,
                            setFetchingStateArray,
                            fetchDashboardTopCategories,
                            clearTopCategories,
                            styles,
                          }) => {
  const charts = { TopSalesCategory: { ...SALES_VAT, labelFields: ['Kategori'] } };
  const [selectedMachineId] = useState(localStorage.getItem(DASHBOARD_MACHINE_ID) || machines[0]?.Id);
  
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (!isLoading) {
      clearTopCategories();
      fetchDashboardTopCategories(allMachineIDs, selectedMachineIds, setIsLoading, setFetchingStateArray);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMachineId, fetchDashboardTopCategories, clearTopCategories, selectedMachineIds]);
  
  if (isLoading || !machines) {
    return <div className={styles.loading}><CircularProgress color="primary" /></div>;
  }
  
  if (!dashboardReports || dashboardReports.TopSalesCategory === '') {
    return <NoDataAvailable />;
  }
  
  return (
    <TranslationsContext.Consumer>
      {({ languageState }) => (
        <>
          <Fade in={true}>
            {!dashboardReports.error &&
            <Paper className={styles.chartCard}>
              <div className={styles.contentTitle}>
                <h3>
                  <FormattedMessage
                    id="page.dashboard.top5CategoriesLastMonth"
                    defaultMessage="Top 5 categories last month"
                  />
                </h3>
                {formatTimestampAsDate(getDateAfterDeductFromToday(0, 1, 0, 0), 'MMMM', { locale: localeMap[languageState] })}
              </div>
              <DashboardChartWrapper
                reports={dashboardReports.TopSalesCategory?.filter(item => item.Kategori !== 'Totalt')}
                chart={charts.TopSalesCategory}
                languageState={languageState} />
            </Paper>
            }
          </Fade>
        </>
      )}
    </TranslationsContext.Consumer>);
};

const decorate = compose(
  withStyles(styles),
  connect(
    store => ({
      machines: store.user.machines,
      dashboardReports: store.report.dashboardCategories,
    }),
    dispatch => bindActionCreators({
      fetchDashboardTopCategories,
      clearTopCategories,
    }, dispatch),
  ),
);

TopSalesCategory.propTypes = {
  dashboardReports: PropTypes.object,
  machines: PropTypes.array,
  machine: PropTypes.string,
  fetchDashboardTopCategories: PropTypes.func,
  clearTopCategories: PropTypes.func,
  styles: PropTypes.object,
};

export default decorate(TopSalesCategory);
